<template>
  <div class="flex flex-wrap lg:flex-nowrap">
        <div class="py-8 pl-8 pr-4">
            <h1 class="font-bold text-xl text-gray-800 mb-2">
                <span class="border-b-2 border-red-700">{{__('Discount for new customers')}} !!</span>
            </h1>
            <h3
                class="text-md text-gray-600 mb-2"
                v-html="__('Receive an attractive :value discount on your first purchase.', { value: `<span class='font-bold text-lg text-red-700'>${value.value}%</span>` })"
            >
            </h3>
        </div>
        <div class="bg-red-700 text-gray-200 md:p-8 p-4 lg:ml-auto lg:w-min w-full flex items-center justify-center">
            <DiscountIcon type="fill" class="w-12 h-12" />
        </div>
    </div>
</template>

<script>
import DiscountIcon from 'UI/Icon/Discount';
export default {
    components: {
        DiscountIcon
    },
    props: ['value'],
}
</script>

<style>

</style>
